/* ============================================================
   Custom client-side wishlist
   - localStorage-backed (key: hatsy_wishlist)
   - Toggles the existing .wk-selected class on .js-product-wishlist
     elements (so theme aesthetic is fully preserved)
   - Listens to a custom 'wishlist:updated' event so all hearts and
     the nav counter stay in sync
   - Renders inside the drawer when opened
   ============================================================ */
(function () {
    var KEY = 'hatsy_wishlist';

    function getList() {
        try {
            var raw = localStorage.getItem(KEY);
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    function saveList(list) {
        try {
            localStorage.setItem(KEY, JSON.stringify(list));
        } catch (e) {
            // Storage might be full or disabled; fail silently
        }
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }

    function getProductFromButton(btn) {
        return {
            id: btn.dataset.productId || btn.dataset.variantId || btn.dataset.productHandle || '',
            variantId: btn.dataset.variantId || '',
            variantTitle: btn.dataset.variantTitle || '',
            title: btn.dataset.productTitle || '',
            price: btn.dataset.productPrice || '',
            image: btn.dataset.productImage || '',
            url: btn.dataset.productUrl || '#'
        };
    }

    function toggle(product) {
        if (!product.id) return false;
        var list = getList();
        var idx = list.findIndex(function (p) { return String(p.id) === String(product.id); });
        if (idx > -1) {
            list.splice(idx, 1);
            saveList(list);
            return false;
        }
        list.push(product);
        saveList(list);
        return true;
    }

    function isInWishlist(id) {
        if (!id) return false;
        return getList().some(function (p) { return String(p.id) === String(id); });
    }

    function syncAllHearts() {
        var btns = document.querySelectorAll('.js-product-wishlist');
        btns.forEach(function (btn) {
            var id = btn.dataset.productId || btn.dataset.variantId || btn.dataset.productHandle;
            btn.classList.toggle('wk-selected', isInWishlist(id));
        });
    }

    function updateNavCounter() {
        var count = getList().length;
        var bubbles = document.querySelectorAll('.js-wishlist-count-bubble');
        bubbles.forEach(function (b) {
            b.textContent = count;
            if (count > 0) {
                b.classList.remove('u-none');
            } else {
                b.classList.add('u-none');
            }
        });
        var headerCount = document.querySelector('.js-drawer-wishlist-count');
        if (headerCount) headerCount.textContent = '(' + count + ')';
        /* Update the subtitle text in the new header design */
        var countText = document.querySelector('.js-drawer-wishlist-count-text');
        if (countText) {
            if (count === 0) countText.textContent = 'No selections yet';
            else if (count === 1) countText.textContent = '1 piece curated';
            else countText.textContent = count + ' pieces curated';
        }
        /* Show/hide footer based on count */
        var footer = document.querySelector('.js-wishlist-footer');
        if (footer) {
            if (count > 0) footer.removeAttribute('hidden');
            else footer.setAttribute('hidden', '');
        }
    }

    function escapeHtml(s) {
        if (!s) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function emptyStateHtml() {
        return '' +
            '<div class="drawer-wishlist__empty-state">' +
                '<div class="drawer-wishlist__empty-illustration" aria-hidden="true">' +
                    '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<circle cx="60" cy="60" r="58" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2 3" opacity="0.3"/>' +
                        '<circle cx="60" cy="60" r="42" stroke="currentColor" stroke-width="0.5" opacity="0.2"/>' +
                        '<path d="M60 84s-22-13.6-22-28c0-7.7 5.6-13 12.5-13 4 0 7 2 9.5 5 2.5-3 5.5-5 9.5-5 6.9 0 12.5 5.3 12.5 13 0 14.4-22 28-22 28z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
                        '<circle cx="60" cy="60" r="2" fill="currentColor" opacity="0.4"/>' +
                    '</svg>' +
                '</div>' +
                '<p class="drawer-wishlist__empty-title">Your wishlist awaits</p>' +
                '<p class="drawer-wishlist__empty-text">Save your favorite pieces by tapping the heart icon on any product. Curate your dream wardrobe here.</p>' +
                '<a href="/collections/all" class="drawer-wishlist__empty-cta js-drawer-close">' +
                    '<span>Discover the collection</span>' +
                    '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true">' +
                        '<path d="M1 5h12m0 0L9 1m4 4L9 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '</svg>' +
                '</a>' +
            '</div>';
    }

    function renderDrawer() {
        var body = document.getElementById('js-drawer-wishlist-body');
        if (!body) return;
        var list = getList();
        if (!list.length) {
            body.innerHTML = emptyStateHtml();
            return;
        }
        var html = '<ul class="drawer-wishlist__list">';
        list.forEach(function (p, idx) {
            var variantId = p.variantId || p.id;
            html += '' +
                '<li class="drawer-wishlist__item" data-id="' + escapeHtml(p.id) + '">' +
                    '<a href="' + escapeHtml(p.url) + '" class="drawer-wishlist__item-image" aria-label="' + escapeHtml(p.title) + '">' +
                        (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
                        '<span class="drawer-wishlist__item-image-overlay" aria-hidden="true">' +
                            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>' +
                        '</span>' +
                    '</a>' +
                    '<div class="drawer-wishlist__item-body">' +
                        '<div class="drawer-wishlist__item-info">' +
                            '<a href="' + escapeHtml(p.url) + '" class="drawer-wishlist__item-title">' + escapeHtml(p.title) + '</a>' +
                            (p.variantTitle && p.variantTitle.toLowerCase() !== 'default title'
                                ? '<span class="drawer-wishlist__item-size">Size ' + escapeHtml(p.variantTitle) + '</span>'
                                : '') +
                            '<div class="drawer-wishlist__item-meta">' +
                                '<span class="drawer-wishlist__item-price">' + p.price + '</span>' +
                            '</div>' +
                        '</div>' +
                        '<div class="drawer-wishlist__item-actions">' +
                            '<button type="button" class="drawer-wishlist__btn drawer-wishlist__btn--add js-wishlist-add-to-cart" data-id="' + escapeHtml(p.id) + '" data-variant-id="' + escapeHtml(variantId) + '" data-product-url="' + escapeHtml(p.url) + '">' +
                                '<span class="drawer-wishlist__btn-label">Add to cart</span>' +
                                '<svg class="drawer-wishlist__btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
                                '<span class="drawer-wishlist__btn-spinner"></span>' +
                            '</button>' +
                            '<button type="button" class="drawer-wishlist__btn drawer-wishlist__btn--remove js-wishlist-remove" data-id="' + escapeHtml(p.id) + '" aria-label="Remove from wishlist">' +
                                '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
                            '</button>' +
                        '</div>' +
                    '</div>' +
                '</li>';
        });
        html += '</ul>';
        body.innerHTML = html;
    }

    /* ============================================================
       SIZE PICKER SUPPORT
       Fetches Shopify product JSON and determines whether the
       product needs a size selection before adding to cart.
       ============================================================ */
    var productDataCache = {};
    function fetchProductData(productUrl) {
        if (!productUrl) return Promise.reject(new Error('no url'));
        /* Strip query/hash for cache key and JSON endpoint */
        var cleanUrl = productUrl.split('?')[0].split('#')[0];
        if (productDataCache[cleanUrl]) {
            return Promise.resolve(productDataCache[cleanUrl]);
        }
        return fetch(cleanUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) {
                if (!r.ok) throw new Error('product fetch failed');
                return r.json();
            })
            .then(function (data) {
                productDataCache[cleanUrl] = data;
                return data;
            });
    }
    function getSizeOptions(product) {
        var result = { hasSizes: false, sizeIndex: -1, options: [] };
        if (!product || !product.variants || !product.variants.length) return result;
        /* Single variant or only variant is "Default Title" — no sizing. */
        if (product.variants.length === 1) {
            var only = product.variants[0];
            var t = (only.title || '').toLowerCase();
            if (t === '' || t === 'default title') return result;
        }
        /* Find the option whose name contains "size" or "taille" */
        var optionsArr = product.options || [];
        var sizeIndex = -1;
        for (var i = 0; i < optionsArr.length; i++) {
            var optName = (typeof optionsArr[i] === 'string' ? optionsArr[i] : (optionsArr[i].name || ''));
            var lower = optName.toLowerCase();
            if (lower.indexOf('size') !== -1 || lower.indexOf('taille') !== -1) {
                sizeIndex = i;
                break;
            }
        }
        /* If product has multiple variants but no option literally named size,
           still treat variant.title as the size selector (since the variant
           title differs). */
        if (sizeIndex === -1) {
            if (product.variants.length > 1) {
                /* Use variant.title as the label */
                result.hasSizes = true;
                result.sizeIndex = -1;
                result.options = product.variants.map(function (v) {
                    return {
                        label: v.title,
                        variantId: v.id,
                        available: v.available
                    };
                });
            }
            return result;
        }
        /* We have a real size option */
        result.hasSizes = true;
        result.sizeIndex = sizeIndex;
        result.options = product.variants.map(function (v) {
            var label = (v.options && v.options[sizeIndex]) || v.title;
            return {
                label: label,
                variantId: v.id,
                available: v.available
            };
        });
        /* Dedupe by label — for products where size is one axis among
           several (e.g. color + size), we only want one button per size. */
        var seen = {};
        result.options = result.options.filter(function (o) {
            if (seen[o.label]) {
                /* If we already saw this label, prefer the available one */
                if (o.available && !seen[o.label].available) {
                    seen[o.label].variantId = o.variantId;
                    seen[o.label].available = true;
                }
                return false;
            }
            seen[o.label] = o;
            return true;
        });
        return result;
    }
    function renderSizePicker(itemEl, sizeInfo, idToRemove, productUrl) {
        if (!itemEl) return;
        var actions = itemEl.querySelector('.drawer-wishlist__item-actions');
        if (!actions) return;
        var pickerHtml = '<div class="drawer-wishlist__size-picker">';
        sizeInfo.options.forEach(function (opt) {
            var disabled = opt.available ? '' : 'disabled aria-disabled="true"';
            pickerHtml += '<button type="button" class="drawer-wishlist__btn drawer-wishlist__btn--size js-wishlist-size-pick' +
                (opt.available ? '' : ' drawer-wishlist__btn--size-unavailable') +
                '" data-variant-id="' + escapeHtml(String(opt.variantId)) +
                '" data-product-url="' + escapeHtml(productUrl) +
                '" data-id="' + escapeHtml(idToRemove) +
                '" ' + disabled + '>' +
                '<span>' + escapeHtml(opt.label) + '</span>' +
                '</button>';
        });
        pickerHtml += '<button type="button" class="drawer-wishlist__btn drawer-wishlist__btn--remove js-wishlist-remove" data-id="' + escapeHtml(idToRemove) + '" aria-label="Remove from wishlist">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>';
        pickerHtml += '</div>';
        actions.outerHTML = pickerHtml;
    }
    function addAndRemove(variantId, productUrl, btn, idToRemove) {
        return addToCart(variantId, productUrl, btn).then(function () {
            var list = getList().filter(function (p) { return String(p.id) !== String(idToRemove); });
            saveList(list);
            renderDrawer();
        });
    }

    function addToCart(variantId, productUrl, btn) {
        if (!variantId) return Promise.resolve();
        if (btn) btn.classList.add('drawer-wishlist__btn--loading');
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: [{ id: parseInt(variantId, 10) || variantId, quantity: 1 }]
            })
        })
        .then(function (r) {
            if (!r.ok) {
                // Variant ID may be a product handle or product id (from older saves).
                // Fetch the product JSON and use the first available variant.
                if (productUrl) {
                    return fetch(productUrl + '.js').then(function (rr) {
                        if (!rr.ok) throw new Error('product fetch failed');
                        return rr.json();
                    }).then(function (product) {
                        var v = (product.variants || []).find(function (x) { return x.available; });
                        if (!v) throw new Error('no available variant');
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
                        });
                    });
                }
                throw new Error('add to cart failed');
            }
            return r;
        })
        .then(function () {
            if (btn) btn.classList.remove('drawer-wishlist__btn--loading');
            // Refresh cart UI
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (window.w3 && window.w3.cart && window.w3.cart.update) {
                window.w3.cart.update();
            }
            // The theme's w3-cart custom element typically refreshes via Shopify's section render
            return fetch('/?sections=drawer-cart').then(function (r) {
                if (r.ok) return r.json();
            }).then(function (sections) {
                if (sections && sections['drawer-cart']) {
                    var oldDrawer = document.querySelector('w3-drawer-cart');
                    if (oldDrawer) {
                        var tmp = document.createElement('div');
                        tmp.innerHTML = sections['drawer-cart'];
                        var newDrawer = tmp.querySelector('w3-drawer-cart');
                        if (newDrawer) {
                            // Just update the cart bubble count and inner cart-products
                            var newCount = tmp.querySelector('.cart-icon-bubble__count');
                            var oldCounts = document.querySelectorAll('.cart-icon-bubble__count');
                            if (newCount) {
                                oldCounts.forEach(function (el) { el.textContent = newCount.textContent; });
                            }
                            var newCartProducts = newDrawer.querySelector('#cart-products');
                            var oldCartProducts = oldDrawer.querySelector('#cart-products');
                            if (newCartProducts && oldCartProducts) {
                                oldCartProducts.replaceWith(newCartProducts);
                            }
                            // Update free-shipping bar
                            var newShipping = newDrawer.querySelector('.cart-free-shipping');
                            var oldShipping = oldDrawer.querySelector('.cart-free-shipping');
                            if (newShipping && oldShipping) {
                                oldShipping.replaceWith(newShipping);
                            }
                            // Update checkout button (price changes)
                            var newCheckout = newDrawer.querySelector('.cart-checkout');
                            var oldCheckout = oldDrawer.querySelector('.cart-checkout');
                            if (newCheckout && oldCheckout) {
                                oldCheckout.replaceWith(newCheckout);
                            }
                        }
                    }
                }
            });
        })
        .catch(function () {
            if (btn) btn.classList.remove('drawer-wishlist__btn--loading');
        });
    }

    // Click handler for any heart button
    document.addEventListener('click', function (e) {
        var heart = e.target.closest('.js-product-wishlist');
        if (heart) {
            e.preventDefault();
            e.stopPropagation();
            var product = getProductFromButton(heart);
            toggle(product);
            return;
        }
        // Add-to-cart from inside drawer: check if size selection is needed
        var addBtn = e.target.closest('.js-wishlist-add-to-cart');
        if (addBtn) {
            e.preventDefault();
            if (addBtn.classList.contains('drawer-wishlist__btn--loading')) return;
            var itemEl = addBtn.closest('.drawer-wishlist__item');
            var idToRemove = addBtn.dataset.id;
            var productUrl = addBtn.dataset.productUrl;
            var variantId = addBtn.dataset.variantId;
            /* Fetch product JSON to find out if size choice is required. */
            addBtn.classList.add('drawer-wishlist__btn--loading');
            fetchProductData(productUrl).then(function (product) {
                var sizeInfo = getSizeOptions(product);
                if (!sizeInfo.hasSizes) {
                    /* No sizes needed — add the first available variant directly. */
                    var firstVariant = (product && product.variants || []).find(function (v) { return v.available; }) || (product && product.variants && product.variants[0]);
                    var idToAdd = (firstVariant && firstVariant.id) || variantId;
                    addBtn.classList.remove('drawer-wishlist__btn--loading');
                    return addAndRemove(idToAdd, productUrl, addBtn, idToRemove);
                }
                /* Multiple sizes — render the size picker inline. */
                addBtn.classList.remove('drawer-wishlist__btn--loading');
                renderSizePicker(itemEl, sizeInfo, idToRemove, productUrl);
            }).catch(function () {
                /* Fallback: try the saved variantId */
                addBtn.classList.remove('drawer-wishlist__btn--loading');
                addAndRemove(variantId, productUrl, addBtn, idToRemove);
            });
            return;
        }
        /* Size button inside the inline size picker */
        var sizeBtn = e.target.closest('.js-wishlist-size-pick');
        if (sizeBtn) {
            e.preventDefault();
            if (sizeBtn.classList.contains('drawer-wishlist__btn--loading')) return;
            if (sizeBtn.disabled || sizeBtn.getAttribute('aria-disabled') === 'true') return;
            var vId = sizeBtn.dataset.variantId;
            var pUrl = sizeBtn.dataset.productUrl;
            var rId = sizeBtn.dataset.id;
            sizeBtn.classList.add('drawer-wishlist__btn--loading');
            addAndRemove(vId, pUrl, sizeBtn, rId);
            return;
        }
        // Add ALL to cart from footer button
        var addAllBtn = e.target.closest('.js-wishlist-add-all');
        if (addAllBtn) {
            e.preventDefault();
            if (addAllBtn.classList.contains('drawer-wishlist__add-all--loading')) return;
            addAllBtn.classList.add('drawer-wishlist__add-all--loading');
            var allItems = getList().slice();
            if (!allItems.length) {
                addAllBtn.classList.remove('drawer-wishlist__add-all--loading');
                return;
            }
            /* Add sequentially so server doesn't get a race */
            var idx = 0;
            function next() {
                if (idx >= allItems.length) {
                    addAllBtn.classList.remove('drawer-wishlist__add-all--loading');
                    saveList([]);
                    renderDrawer();
                    return;
                }
                var p = allItems[idx++];
                /* For "Add all", we use the saved variant or first-available;
                   we don't prompt for size since there's no UI for it here. */
                addToCart(p.variantId || p.id, p.url, null).then(next, next);
            }
            next();
            return;
        }
        // Remove button inside drawer
        var removeBtn = e.target.closest('.js-wishlist-remove');
        if (removeBtn) {
            e.preventDefault();
            var id = removeBtn.dataset.id;
            var list = getList().filter(function (p) { return String(p.id) !== String(id); });
            saveList(list);
            renderDrawer();
            return;
        }
        // Open-drawer button: render fresh just before drawer opens
        var openBtn = e.target.closest('.js-open-drawer-wishlist');
        if (openBtn) {
            renderDrawer();
        }
    });

    // Sync on update
    document.addEventListener('wishlist:updated', function () {
        syncAllHearts();
        updateNavCounter();
        // If drawer is open, re-render it
        var drawerEl = document.querySelector('.js-drawer-wishlist');
        if (drawerEl && drawerEl.classList.contains('drawer--visible')) {
            renderDrawer();
        }
    });

    // Init on DOM ready
    function init() {
        syncAllHearts();
        updateNavCounter();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-sync when product cards are loaded dynamically (filters, load more, etc.)
    document.addEventListener('theme:filters:update', syncAllHearts);
    document.addEventListener('theme:search:update', syncAllHearts);
    document.addEventListener('product-recommendations:update', syncAllHearts);
    document.addEventListener('listing-load-more:loaded', syncAllHearts);
})();

/* ============================================================
   Model info drawer — swap photo + caption based on which model
   name was clicked. The clicked button now carries the model's
   src/name/caption as data attributes directly, so there's no
   coupling between the trigger button and the drawer's data.
   ============================================================ */
(function () {
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-open-drawer-model');
        if (!btn) return;
        var photo = document.querySelector('.js-drawer-model-photo');
        var nameEl = document.querySelector('.js-drawer-model-name');
        var captionEl = document.querySelector('.js-drawer-model-caption');
        if (!photo) return;
        /* Prefer data directly on the button. Falls back to the photo's
           data-model-N-* attributes for backward compatibility. */
        var src = btn.dataset.modelSrc;
        var name = btn.dataset.modelName;
        var caption = btn.dataset.modelCaption;
        if (!src) {
            var modelNum = btn.dataset.model || '1';
            src = photo.dataset['model' + modelNum + 'Src'];
            name = photo.dataset['model' + modelNum + 'Name'];
            caption = photo.dataset['model' + modelNum + 'Caption'];
        }
        if (src) photo.src = src;
        if (nameEl && name) nameEl.textContent = name;
        if (captionEl && caption) captionEl.textContent = caption;
    });
})();

/* ============================================================
   Reassurance carousel — auto-rotating dots and slides
   ============================================================ */
(function () {
    function initCarousel(el) {
        var slides = el.querySelectorAll('.product__reassurance-slide');
        var dots = el.querySelectorAll('.product__reassurance-dot');
        if (!slides.length) return;
        var current = 0;

        function show(idx) {
            slides.forEach(function (s, i) {
                s.classList.toggle('product__reassurance-slide--active', i === idx);
            });
            dots.forEach(function (d, i) {
                d.classList.toggle('product__reassurance-dot--active', i === idx);
            });
            current = idx;
        }

        var interval = setInterval(function () {
            show((current + 1) % slides.length);
        }, 2800);

        dots.forEach(function (d) {
            d.addEventListener('click', function () {
                clearInterval(interval);
                show(parseInt(d.dataset.reassuranceDot, 10) || 0);
                interval = setInterval(function () {
                    show((current + 1) % slides.length);
                }, 2800);
            });
        });
    }

    function initAll() {
        document.querySelectorAll('[data-reassurance-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();

/* ============================================================
   Out-of-stock "Create an Alert" button — delegates to Stoq's
   Restock Rocket button. The Stoq container is hidden by
   component-stock-alert.js but kept in the DOM so we can click it.
   ============================================================ */
(function () {
    function findStoqButton() {
        // Try multiple selectors used by Restock Rocket / Stoq
        var selectors = [
            '.restock-rocket-button-container button',
            '.restock-rocket-button-container a',
            '.restock-rocket-button',
            '[data-restock-rocket]',
            '[class*="back-in-stock"] button',
            '[class*="notify-me"] button',
            '[id*="restock-rocket"] button',
            '[id*="restock-rocket"] a',
            '.stoq-button',
            '#stoq-button',
            'button[class*="restock"]'
        ];
        for (var i = 0; i < selectors.length; i++) {
            var el = document.querySelector(selectors[i]);
            if (el) return el;
        }
        return null;
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-form__create-alert-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        var stoq = findStoqButton();
        if (stoq) {
            // Temporarily reveal it so the click triggers properly
            // (some apps check element visibility before opening)
            var container = stoq.closest('.restock-rocket-button-container') || stoq;
            var originalCss = container.style.cssText;
            container.style.cssText = 'position:absolute;left:0;top:0;opacity:0;pointer-events:auto;';
            try {
                stoq.click();
            } catch (err) {}
            // Restore the hidden state after a tick (after the modal opens)
            setTimeout(function () {
                container.style.cssText = originalCss || 'display:none;visibility:hidden;position:absolute;left:-9999px;';
            }, 100);
        }
    });
})();

/* ============================================================
   Keep wishlist button's data-variant-title in sync with the
   currently-selected size on the product page. When user picks a
   size on the product page, variant-radios fires a 'change' event;
   we read the selected label text and update the heart's dataset.
   ============================================================ */
(function () {
    function syncProductPageVariantTitle() {
        var radiosEl = document.querySelector('variant-radios');
        if (!radiosEl) return;
        var heartBtn = document.querySelector('.product__wishlist-button.js-product-wishlist');
        if (!heartBtn) return;
        /* Find the currently-checked size input by looking for a fieldset
           whose legend/name mentions size, then reading the checked input
           value. Falls back to whichever radio is checked. */
        var fieldsets = radiosEl.querySelectorAll('fieldset');
        var sizeValue = '';
        for (var i = 0; i < fieldsets.length; i++) {
            var fs = fieldsets[i];
            var legendText = (fs.querySelector('legend') || {}).textContent || '';
            var nameAttr = (fs.querySelector('input') || {}).name || '';
            var label = (legendText + ' ' + nameAttr).toLowerCase();
            if (label.indexOf('size') === -1 && label.indexOf('taille') === -1) continue;
            var checked = fs.querySelector('input:checked');
            if (checked) {
                sizeValue = checked.value || '';
                break;
            }
        }
        /* Fallback: first checked radio of any kind */
        if (!sizeValue) {
            var anyChecked = radiosEl.querySelector('input:checked');
            if (anyChecked) sizeValue = anyChecked.value || '';
        }
        if (sizeValue && sizeValue.toLowerCase() !== 'default title') {
            heartBtn.dataset.variantTitle = sizeValue;
        }
    }
    /* Listen to variant-radios change events (bubbles) */
    document.addEventListener('change', function (e) {
        var radios = e.target.closest && e.target.closest('variant-radios');
        if (!radios) return;
        /* Wait a tick so variant-radios finishes updating internal state */
        setTimeout(syncProductPageVariantTitle, 0);
    });
    /* Run once on load to ensure the initial state is correct */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncProductPageVariantTitle);
    } else {
        syncProductPageVariantTitle();
    }
})();
